import React from 'react'
import './Projects.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faO } from '@fortawesome/free-solid-svg-icons'
import { faOpera } from '@fortawesome/fontawesome-free-brands'
import img1 from '../../../images/New-Event.png'
import img2 from '../../../images/eCommerce.png'
import img3 from '../../../images/movie-app.png'
import img4 from '../../../images/Template Dashboard.png'
import img5 from '../../../images/JavaScript-Project.png'
import img6 from '../../../images/cafeshop.png'
import img7 from '../../../images/Bondii.png'
import img8 from '../../../images/resturent.png'
import img9 from '../../../images/bookstore.png'
import img10 from '../../../images/company.png'
import img11 from '../../../images/testing-portfolio.png'
import img12 from '../../../images/First-Project.png'
import img13 from '../../../images/Project-two.png'
import img14 from '../../../images/Project-Three.png'
import img15 from '../../../images/github-profile.png'
import img16 from '../../../images/CRUDS APP.png'
import img17 from '../../../images/ShoppingCart.png'
import img18 from '../../../images/MediTro.png'
import img19 from '../../../images/Recipe App.png'
import img20 from '../../../images/Weather App.png'
import img21 from '../../../images/Cryptocurrency APP.png'
import img22 from '../../../images/fylo.png'
import img23 from '../../../images/Code..png'
import img24 from '../../../images/Maltimare - Home.png'
import img25 from '../../../images/Rounah.png'
import img26 from '../../../images/Food Delivery - Home.png'

function Projects() {
//     let allTabs = document.querySelectorAll(".tabs button");
//     let allBoxes = document.querySelectorAll(".container-projects .box");
  
//     allTabs.forEach((e) => {
//     e.addEventListener("click", function (e) {
//       allTabs.forEach((e) => {
//         e.classList.remove("active");
//       });
//       e.currentTarget.classList.add("active");
//       if (e.currentTarget.classList.contains("all-butt")) {
//         allBoxes.forEach((e) => {
//           e.style.display = "block";
//         });
//       } else if (e.currentTarget.classList.contains("design-butt")) {
//         allBoxes.forEach((e) => {
//           e.style.display = "none";
//           if (e.classList.contains("react")) {
//             e.style.display = "block";
//           }
//         });
//       } 
//       else if (e.currentTarget.classList.contains("other-butt")) {
//           allBoxes.forEach((e) => {
//             e.style.display = "none";
//             if (e.classList.contains("others")) {
//               e.style.display = "block";
//             }
//           });
//         }else {
//         allBoxes.forEach((e) => {
//           e.style.display = "none";
//           if (e.classList.contains("js")) {
//             e.style.display = "block";
//           }
//         });
//       }
//     });
//   });
  

  return (
    <>
        <div className="projects" id='projects'>
            <div className="container">
                <h1 data-aos="zoom-in" data-aos-duration="2500">BL<FontAwesomeIcon icon={faO} />G</h1>
                <FontAwesomeIcon icon={faOpera} />
                <div className='title' data-aos="zoom-in" data-aos-duration="2500">
                    <span>Projects I Have Worked In</span>
                </div>
                {/* <div className="tabs" data-aos="fade-down" data-aos-duration="3000">
                    <button className="all-butt active">All</button>
                    <button className="design-butt">React</button>
                    <button className="web-butt">JS</button>
                    <button className="other-butt">Other</button>
                </div> */}
                <div className="container-projects" data-aos="fade-up" data-aos-duration="3000">
                    <div className="box react">
                        <p>Multimart</p>
                        <img src={img24} alt="{img24}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/maltimart" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/maltimart" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>Tasty Treat</p>
                        <img src={img26} alt="{img26}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/TastyTreat/" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/TastyTreat" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>MediTro</p>
                        <img src={img18} alt="{img19}" />
                        <div className="links">
                            <a className='demo' href="https://meditro.netlify.app/" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/MediTro" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>Rounah</p>
                        <img src={img25} alt="{img25}" />
                        <div className="links">
                            <a className='demo' href="https://kaairatalrounah.sa/" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Rounah" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>CRUDS App</p>
                        <img src={img16} alt="{img16}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/CRUDS-APP" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/CRUDS-APP" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>Movie App</p>
                        <img src={img3} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://m0vie-app.netlify.app/" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Movie-App" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>Dashboard</p>
                        <img src={img4} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Dashboard" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Dashboard" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>Recipe App</p>
                        <img src={img19} alt="{img19}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Recipe-App/" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Recipe-App" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>Weather App</p>
                        <img src={img20} alt="{img20}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Weather-App/" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Weather-App" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>Fylo</p>
                        <img src={img22} alt="{img22}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Fylo/" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Fylo" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>New Event</p>
                        <img src={img1} alt="{img1}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Project-React" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Project-React" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>eCommerce</p>
                        <img src={img2} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/eCommerce" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/eCommerce" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>

                    <div className="box react">
                        <p>Code.</p>
                        <img src={img23} alt="{img23}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/code./" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/code." target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>Cryptocurrency App </p>
                        <img src={img21} alt="{img21}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Cryptocurrency_App/" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Cryptocurrency_App" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box react">
                        <p>Shopping Cart</p>
                        <img src={img17} alt="{img17}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/ShoppingCart/" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/ShoppingCart" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>JS(ES6) Project</p>
                        <img src={img5} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/JS-ES6--Project" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/JS-ES6--Project" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>CafeShop</p>
                        <img src={img6} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/CafeShop" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/CafeShop" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>Bondi</p>
                        <img src={img7} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Bondii" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Bondii" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>Resturant</p>
                        <img src={img8} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Resturant" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Resturant" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>Book Store</p>
                        <img src={img9} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Bookstore" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Bookstore" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>Company </p>
                        <img src={img10} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Company" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Company" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>Testing-Portfolio </p>
                        <img src={img11} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Testing-Portofolio" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Testing-Portofolio" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>Template One Elzero</p>
                        <img src={img12} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Template-1-Landing-Page-with-hover/" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Template-1-Landing-Page-with-hover"target='_blank' rel='noreferrer' >Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>Template Two Elzero</p>
                        <img src={img13} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Template-Using-Animation-" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Template-Using-Animation-" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box js">
                        <p>Template Three Elzero</p>
                        <img src={img14} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://islamelhadidy.github.io/Template_Three-Pure-Animation-" target='_blank' rel='noreferrer'>Live Demo</a>
                            <a className='github' href="https://github.com/IslamElhadidy/Template_Three-Pure-Animation-" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                    <div className="box others">
                        <p>Other Projects</p>
                        <img src={img15} alt="{img2}" />
                        <div className="links">
                            <a className='demo' href="https://github.com/IslamElhadidy?tab=repositories" target='_blank' rel='noreferrer'>Github</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="seperator">
        </div>
        </div>

    </>
  )
}

export default Projects